export const getLocation = (resultsType) => {
  // Save location so we can work out distance of result from this
  let location;
  if (resultsType._type === "hotel" || resultsType._type === "attraction") {
    if (resultsType.location && resultsType.location.lat) {
      location = resultsType.location;
    }
  } else if (resultsType._type === "pillar" && resultsType.mapSearchOptions) {
    if (
      resultsType.mapSearchOptions.filterByLocation &&
      resultsType.mapSearchOptions.filterByLocation.lat
    ) {
      location = resultsType.mapSearchOptions.filterByLocation;
    }
  }
  if (resultsType._type === "pillar" && resultsType.hotelSearchOptions) {
    if (resultsType.hotelSearchOptions.filterByCounty) {
      location = {
        type: "county",
        value: resultsType.hotelSearchOptions.filterByCounty,
      };
    }
  }

  // return (location = { lat: 54.01970339621212, lng: -1.082073222029217 });

  return location;
};
